import type { StartTrackingResult } from "../types";

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null && !Array.isArray(value);
}

function parseResultObject(value: unknown): StartTrackingResult | null {
  if (!isRecord(value)) {
    return null;
  }

  const status = value.status;
  const trackerId =
    typeof value.trackerId === "string"
      ? value.trackerId
      : typeof value.tracker_id === "string"
        ? value.tracker_id
        : "";

  if (status !== "ACTIVE" || !trackerId.trim()) {
    return null;
  }

  return { status: "ACTIVE", trackerId: trackerId.trim() };
}

function parseResultString(value: string): StartTrackingResult | null {
  const trimmed = value.trim();
  if (!trimmed) {
    return null;
  }

  try {
    return parseResultObject(JSON.parse(trimmed) as unknown);
  } catch {
    return null;
  }
}

/** start_tracking 是否已进入 tracked（ACTIVE）态 */
export function hasStartTrackingResult(result: unknown): boolean {
  return parseStartTrackingResult(result) !== null;
}

export function parseStartTrackingResult(
  result: unknown,
): StartTrackingResult | null {
  if (result == null || result === "") {
    return null;
  }

  if (typeof result === "string") {
    return parseResultString(result);
  }

  return parseResultObject(result);
}

/** 构造本地 merge 的 start_tracking result JSON */
export function buildStartTrackingResult(trackerId: string): string {
  const payload: StartTrackingResult = {
    status: "ACTIVE",
    trackerId: trackerId.trim(),
  };
  return JSON.stringify(payload);
}
